import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { HistoryModel } from "@/views/historyModel";
import { useSoReportModel } from "../soReportModel";
//销售单报表
export default () => {
    const {
        historyVisible, setHistoryVisible,
        historyRow
    } = useSoReportModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <HistoryModel
                visible={historyVisible}
                materialCode={historyRow?.materialCode as string}
                materialName={historyRow?.materialName as string}
                onCancel={() => setHistoryVisible(false)}
            />
        </>
    )
}